/*
  Öffnet die Dropdowns im Header schon beim Hovern.

  Dawn baut die Menüs aus <details>/<summary>, die von Haus aus nur auf Klick
  aufgehen. Rein per CSS lässt sich das nicht lösen: geschlossene <details>
  verstecken ihren Inhalt über das UA-Stylesheet, und Chrome nutzt dafür
  inzwischen content-visibility, was sich nicht zuverlässig überschreiben lässt.
  Deshalb wird das open-Attribut hier per JS gesetzt.

  Nur auf Geräten, die wirklich hovern können, und nur ab der Breite, ab der
  Dawn die Inline-Navigation überhaupt zeigt.
*/
(() => {
  const HOVER_QUERY = '(hover: hover) and (min-width: 990px)';
  const CLOSE_DELAY = 150; // gegen Flackern beim diagonalen Rausfahren

  const canHover = window.matchMedia(HOVER_QUERY);

  function enhance(details) {
    if (details.dataset.hoverReady) return;
    details.dataset.hoverReady = 'true';

    const summary = details.querySelector('summary');
    if (!summary) return;

    let closeTimer = null;
    let openedByHover = false;

    const open = () => {
      clearTimeout(closeTimer);
      if (details.open) return;
      details.open = true;
      summary.setAttribute('aria-expanded', 'true');
      openedByHover = true;
    };

    const close = () => {
      closeTimer = setTimeout(() => {
        if (!openedByHover) return;
        details.open = false;
        summary.setAttribute('aria-expanded', 'false');
        openedByHover = false;
      }, CLOSE_DELAY);
    };

    details.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'mouse' || !canHover.matches) return;
      open();
    });

    details.addEventListener('pointerleave', (event) => {
      if (event.pointerType !== 'mouse' || !canHover.matches) return;
      close();
    });

    // Ein Klick auf das schon per Hover geöffnete Menü würde es sonst zuklappen
    summary.addEventListener('click', (event) => {
      if (openedByHover && canHover.matches) event.preventDefault();
    });

    // Tastaturbedienung bleibt Dawns Klick-Logik überlassen
    summary.addEventListener('keydown', () => {
      openedByHover = false;
    });
  }

  function init() {
    // Nur die oberste Ebene. Dawn wickelt die in <header-menu>, die Unterebenen
    // sind nackte <details> im Submenü — die sollen beim Klick bleiben, sonst
    // klappen sie schon auf, wenn man nur an ihnen vorbeifährt.
    document
      .querySelectorAll('.header__inline-menu header-menu > details')
      .forEach((details) => {
        if (details.closest('.header__submenu')) return;
        enhance(details);
      });
  }

  document.addEventListener('DOMContentLoaded', init);
  // Der Header wird im Theme-Editor neu gerendert
  document.addEventListener('shopify:section:load', init);
  init();
})();
